import SettingsIcon from "@mui/icons-material/Settings";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { Fragment } from "react";
import ApplicationLogoutIco from "../../../../assets/icons/ApplicationLogoutIco";
import CommonButton from "../../../../component/Button";
import { CommonGrid2 } from "../../../../modules/common-components/StyledComponents";
import { CommonTippy } from "../../../../modules/jobs/style";

export default function SettingSideBar({
  settingDialog,
  handleNavigation,
  handleSettingToggleDrawer,
  handleApplicationLogout,
  theme,
  lgUp,
  selected,
  handleSelect,
  SidebarItems,
}) {
  return (
    <Fragment>
      <Drawer
        variant="permanent"
        open={settingDialog.sidenav}
        anchor="left"
        onClose={handleSettingToggleDrawer}
        disablePortal
        sx={{
          "& .MuiDrawer-paper": {
            transition: theme.transitions.create("width", {
              duration: theme.transitions.duration.standard,
            }),
            overflowX: "hidden",
            position: "relative",
          },

          position: "relative",
        }}
      >
        <CommonGrid2
          container
          direction="column"
          height={"calc(100vh - 4rem)"}
          flexWrap={"nowrap"}
          padding={"16px"}
          margin={0}
        >
          <CommonGrid2 item margin={"8px"} sx={{ cursor: "pointer" }}>
            {!settingDialog.sidenav ? (
              <SettingsIcon />
            ) : (
              <Typography variant="h2">Settings</Typography>
            )}
          </CommonGrid2>

          <CommonGrid2
            item
            flexGrow={1}
            overflowY={"auto"}
            width={settingDialog.sidenav ? "calc(100% + 16px)" : "fit-content"}
            scrollStyle
            marginBottom={"12px"}
            scrollBar="5px"
            paddingRight={"10px"}
          >
            <List sx={{ width: "100%" }} component="nav">
              {SidebarItems.map((item, index) => (
                <Fragment key={item.name}>
                  <ListItemButton
                    onClick={() => handleSelect(item)}
                    selected={item.index === selected.index}
                    sx={{
                      width: settingDialog.sidenav ? "100%" : "max-content",
                      padding: "8px 8px",
                      background:
                        item.index === selected.index ? "rgb(230 230 230)" : "",
                      borderRadius: "10px",
                      boxShadow:
                        item.index === selected.index &&
                        "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                    }}
                  >
                    <CommonTippy
                      content={item.name}
                      placement="right"
                      disabled={settingDialog.sidenav}
                      color="#7F56D9"
                      fontWeight={600}
                      fontSize={"13px"}
                    >
                      <ListItemIcon
                        sx={{
                          justifyContent: "flex-start",
                          minWidth: "40px",
                        }}
                      >
                        {React.cloneElement(item.icon, {
                          color:
                            item.index === selected.index
                              ? "#7F56D9"
                              : "#667085",
                        })}
                      </ListItemIcon>
                    </CommonTippy>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body4"
                          fontWeight={item.index === selected.index ? 700 : 600}
                          color={
                            item.index === selected.index
                              ? "#7F56D9"
                              : "#101828"
                          }
                        >
                          {item.name}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </Fragment>
              ))}
            </List>
          </CommonGrid2>

          <CommonButton
            value={"Logout"}
            startIcon={<ApplicationLogoutIco />}
            color={"#101828"}
            onClick={handleApplicationLogout}
            fontWeight={600}
            fontSize={"16px"}
            padding={"16px"}
            backgroundColor="transparent"
            boxShadow={"none"}
            customStyle={{
              justifyContent: "start",

              "&:hover": {
                boxShadow: "none",
              },
            }}
          />
        </CommonGrid2>
      </Drawer>
    </Fragment>
  );
}
